export default __webpack_public_path__ + "static/media/icon-edit-white.d839426c.svg";